export const movies = [
  {
    image: "https://preview.redd.it/cxgzi7jvs2r51.jpg?auto=webp&s=54a1bd4b447a2ef9a7a8d7d528d035854d7f0f49",
    title: "The Lost Expedition",
    videoLink: "https://www.youtube.com/embed/dW1BIid8Osg",
    director: "Richard Clarkson",
    starring: [
      "Hugh Jackman",
      "Emily Blunt",
      "Robert Pattinson"
    ],
    description: "In the heart of the Amazon rainforest, a group of explorers stumbles upon an ancient map leading to a forgotten civilization. Facing dense jungles, treacherous rivers, and hostile creatures, they must work together to uncover the secrets of a lost city. But as they dig deeper into the mystery, they realize that some secrets are better left buried. The expedition turns into a fight for survival as they are hunted by a dangerous force guarding the hidden treasure."
  },
  {
    image: "https://tse1.mm.bing.net/th?id=OIP.3xd8s2gvFjLpkPx8OUAPowHaEK&pid=Api&P=0&h=180",
    title: "The Haunted Manor",
    videoLink: "https://www.youtube.com/embed/HpLZyrTLv8A",
    director: "Samantha Gray",
    starring: [
      "Vera Farmiga",
      "Patrick Wilson",
      "Milly Shapiro"
    ],
    description: "When a family inherits a long-abandoned mansion in the countryside, they believe they’ve stumbled upon the perfect getaway. But as strange occurrences begin to unravel, they soon discover that the house holds a dark, malevolent history. What started as a peaceful retreat turns into a nightmarish battle for their souls. With eerie apparitions and terrifying phenomena haunting them, the family must uncover the house's deadly secrets before it's too late. A chilling thriller that will keep you on the edge of your seat."
  },
  {
    image: "https://tse4.mm.bing.net/th?id=OIP.dkHDPgSki_4eR3LzV1ePMAHaKK&pid=Api&P=0&h=180",
    title: "The Mountain of Laughter",
    videoLink: "https://www.youtube.com/embed/y6120QOlsfU",
    director: "Tommy McLaughlin",
    starring: [
      "Adam Sandler",
      "Kevin Hart",
      "Tiffany Haddish"
    ],
    description: "Three lifelong friends embark on a hiking trip in the Rocky Mountains, hoping for some peace and relaxation. However, their journey quickly descends into comedic chaos when they find themselves hopelessly lost, with only their wit and terrible navigation skills to rely on. Along the way, they encounter wild animals, eccentric locals, and hilarious mishaps that test the strength of their friendship. Packed with laugh-out-loud moments and a heartwarming message, this feel-good comedy is perfect for anyone who loves adventure and humor."
  },
  {
    image: "https://tse4.mm.bing.net/th?id=OIP.dEt4McR1tJBstNCCFff3RQAAAA&pid=Api&P=0&h=180",
    title: "Shadows in the Forest",
    videoLink: "https://www.youtube.com/embed/FE_pXWBkl6I",
    director: "Nina Roberts",
    starring: [
      "Anya Taylor-Joy",
      "David Harbour",
      "Florence Pugh"
    ],
    description: "A group of friends set out for a weekend camping trip deep within a remote forest. What begins as a carefree getaway soon turns into a fight for their lives when they are stalked by a terrifying presence lurking in the woods. As night falls, they must rely on their instincts and wits to survive the unknown entity that seems to know their every move. A spine-tingling horror film that plays on the primal fear of the dark and the mysteries of the wilderness, delivering shocks and suspense at every turn."
  },
  {
    image: "https://tse4.mm.bing.net/th?id=OIP.153Q12ysiP34fnpgwsY6egHaHa&pid=Api&P=0&h=180",
    title: "Jungle of Mysteries",
    videoLink: "https://www.youtube.com/embed/8vBO97D7l_A",
    director: "Steven Lucas",
    starring: [
      "Chris Pratt",
      "Bryce Dallas Howard",
      "Jake Gyllenhaal"
    ],
    description: "A former archaeologist and a team of scientists are drawn into the depths of an unexplored jungle in search of a legendary artifact rumored to hold great power. Along the way, they encounter perilous landscapes, ancient traps, and wild animals that test their resilience. As they venture further, they realize that they are not alone in the jungle—an ancient civilization, thought to be extinct, is protecting its secrets at any cost. Adventure, action, and mystery come together in this edge-of-your-seat thrill ride."
  },
  {
    image: "https://tse2.mm.bing.net/th?id=OIP.FRTTDeRAngPSxcJEm_G9-QHaEo&pid=Api&P=0&h=180",
    title: "Desperate Laughter",
    videoLink: "https://www.youtube.com/embed/Ik7D7BWoLFM",
    director: "Claire Higgins",
    starring: [
      "Steve Carell",
      "Kristen Wiig",
      "Will Ferrell"
    ],
    description: "When an aspiring comedian's career hits rock bottom, he reluctantly joins a cross-country tour with two fellow washed-up comics. The trio encounters a series of hilarious and unexpected adventures, from disastrous performances to run-ins with strange audiences. As they bond over their shared failures, they discover that laughter might be the best medicine after all. Filled with witty dialogue, slapstick humor, and heartfelt moments, this road-trip comedy is a hilarious look at life’s ups and downs."
  },
  {
    image: "https://tse1.mm.bing.net/th?id=OIP.dpd4sbn_w-88EzUmfBhkrQHaEK&pid=Api&P=0&h=180",
    title: "Midnight Terror",
    videoLink: "https://www.youtube.com/embed/2bF22g1rlyU",
    director: "Jake Harrison",
    starring: [
      "Ethan Hawke",
      "Jenna Ortega",
      "Bill Skarsgård"
    ],
    description: "When a small town is plagued by a series of brutal murders, a troubled detective is called in to solve the case. As he delves deeper into the mystery, he uncovers a dark conspiracy involving supernatural forces that have haunted the town for centuries. With each passing night, the terror intensifies, leading to a horrifying climax that will leave audiences gasping for breath. Midnight Terror is a gripping horror thriller filled with jump scares, eerie atmosphere, and unexpected twists."
  },
  {
    image: "https://tse1.mm.bing.net/th?id=OIP.o6x2FabjEACkvoMKQ1VEWwHaFW&pid=Api&P=0&h=180",
    title: "Laughter on the Run",
    videoLink: "https://www.youtube.com/embed/0D6iL9VEVwM",
    director: "Greg Daniels",
    starring: [
      "Melissa McCarthy",
      "Ken Jeong",
      "John C. Reilly"
    ],
    description: "When two bumbling criminals botch a robbery and find themselves on the run, they are forced to disguise themselves as contestants in a cross-country race. Along the way, they encounter a cast of eccentric characters, all while trying to evade the law. With slapstick comedy and nonstop action, 'Laughter on the Run' delivers hilarious misadventures that will keep audiences laughing from start to finish. A fast-paced comedy with heart, full of unpredictable twists and turns."
  },
  {
    image: "https://tse4.mm.bing.net/th?id=OIP.8PC6HhdxpqxzOFGBtaf73QHaL2&pid=Api&P=0&h=180",
    title: "Echoes of the Abyss",
    videoLink: "https://www.youtube.com/embed/S6U6MBdyi5Y",
    director: "Rebecca Thomas",
    starring: [
      "Tom Hardy",
      "Jessica Chastain",
      "Oscar Isaac"
    ],
    description: "A marine biologist and her team embark on an underwater expedition to explore a newly discovered deep-sea trench. As they descend into the abyss, they encounter strange and dangerous creatures that have evolved in complete darkness. But the true danger lies deeper still—an ancient force has been awakened, and it threatens to destroy everything in its path. With stunning visuals and intense action, 'Echoes of the Abyss' is a gripping adventure that takes viewers to the farthest depths of the ocean."
  }
];
